import { createProfessionalExporter } from '../../utils/professionalExport';

const headers = ['Type', 'Serial No', 'Name', 'Date', 'Check In', 'Check Out', 'Status'];

const exporter = createProfessionalExporter({
  title: 'Attendance Report',
  headers,
  slug: 'attendance',
  getRows: (list) =>
    list.map((r) => [
      r.type || 'Member',
      r.gymId || '—',
      r.member,
      r.date,
      r.checkIn,
      r.checkOut || '—',
      r.statusLabel || (r.status === 'in-gym' ? 'In Gym' : 'Completed'),
    ]),
  getSummary: (list) => [
    `Total records: ${list.length}`,
    `Currently in gym: ${list.filter((r) => r.status === 'in-gym').length}`,
  ],
});

export const printAttendanceList = (data) => exporter.print(data);
export const exportAttendanceCsv = (data) => exporter.csv(data);
export const exportAttendanceExcel = (data) => exporter.excel(data);
export const exportAttendancePdf = (data) => exporter.pdf(data);
export const exportAttendance = (data) => exporter.export(data);
